/**
 * Action to delete Scheduled maintenance details
 */
export enum deleteScheduledMaintenance {
  DELETE_SCHEDULED_MAINTENANCE_REQUEST = 'DELETE_SCHEDULED_MAINTENANCE_REQUEST'
}
